import {
  SET_GYM_DASHBOARD_CARD_DATA,
  SET_GYM_DASHBOARD_LIVE_DATA,
  SET_BOOKINGS,
  SET_SALES,
  SET_EXPANSION_COUNT,
  SET_EXPANSION_SUMMARY
} from "../types/types";

export const setGymDashboardCardData = value => {
  return {
    type: SET_GYM_DASHBOARD_CARD_DATA,
    payload: { data: value }
  };
};
export const setGymLiveClassCardData = value => {
  return {
    type: SET_GYM_DASHBOARD_LIVE_DATA,
    payload: { data: value }
  };
};

export const setBookings = value => {
  return {
    type: SET_BOOKINGS,
    payload: { data: value }
  };
};
export const setSales = value => {
  return {
    type: SET_SALES,
    payload: { data: value }
  };
};
export const setExpansionCount = value => {
  return {
    type: SET_EXPANSION_COUNT,
    payload: { data: value }
  };
};
export const setExpansionSummary = value => {
  return {
    type: SET_EXPANSION_SUMMARY,
    payload: { data: value }
  };
};
export const setDashboardWeeklySchedule = value => {
  return {
    type: "SET_DASHBOARD_WEEKLY_SCHEDULE",
    payload: { data: value }
  };
};
export const setDashboardCharts = value => {
  return {
    type: "SET_DASHBOARD_CHARTS",
    payload: { data: value }
  };
};
